import React from "react";
import {useNavigate} from "react-router-dom";
import {ASSET_MAINTENANCE_HEADER} from "../../../../components/table/header/Headers";
import useRequestData from "../../../../hooks/useRequestData";
import {selectMaintenanceListByAsset} from "../../../../api/maintenance/MaintenanceAssetService";
import SearchSection from "../../../../components/search/SearchSection";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import Search from "../../../../components/search/Search";
import {nonObject, toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import DetailLinkedListView from "../../../../components/detailLayout/DetailLinkedListView";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";

const listType = [
    {id: "INSPECTION", name: "점검"},
    {id: "INCIDENT", name: "장애"},
    {id: "WORK", name: "작업"},
];

const MAINTENANCE_DETAIL_URL = {
    INSPECTION: (rowId) => `/maintenance/inspection/${rowId}`,
    INCIDENT: (rowId) => `/maintenance/incident/${rowId}`,
    WORK: (rowId) => `/maintenance/work/${rowId}`,
};

const TYPE_TO_ENTITY = {
    "점검": "INSPECTION",
    "장애": "INCIDENT",
    "작업": "WORK",
};

function AssetMaintenance({id}) {
    const navigate = useNavigate();
    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const {newData, pageInfo, dataHook} = useRequestData((conditions, pageable) => {
        const additionalCondition = {
            entityId: id,
        };
        const finalConditions = {
            ...conditions,
            ...additionalCondition,
        };
        return selectMaintenanceListByAsset(finalConditions, pageable);
    }, initDate);

    const {handleSearch, handlePageSizeChange, saveConditions, handleGridPageChange} = dataHook;
    const searchDate = {
        startDate: saveConditions.startDate ?? initDate.startDate,
        endDate: saveConditions.endDate ?? initDate.endDate,
    };

    const handleRowClick = (row) => {
        const rowId = row?.id;
        const entityName = row?.entityName ?? TYPE_TO_ENTITY[row?.type];
        // 목록 API는 id 없이 linkUrl을 내려준다 (SimmsTable/TableMovable과 동일 규칙)
        const url = row?.linkUrl || (rowId != null ? MAINTENANCE_DETAIL_URL[entityName]?.(rowId) : null);
        if (!url) return;

        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "유지보수 상세"),
            url,
        });
    };

    return (
        <DetailLinkedListView
            headerDefinition={ASSET_MAINTENANCE_HEADER}
            settingKey="asset_maintenance"
            newData={newData}
            onPageChange={handleGridPageChange}
            onRowClick={handleRowClick}
        >
            <Search
                handleSearch={handleSearch}
                searchConditions={saveConditions}
                handlePageSizeChange={handlePageSizeChange}
                pageInfo={pageInfo}
                size
                date={searchDate}
                detail
                searchBar={{placeHolder: "제목"}}
            >
                <SearchSection>
                    <SearchComboBox
                        title={"구분"}
                        code={listType}
                        target={"entityName"}
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "entityName")}
                    />
                </SearchSection>
            </Search>
        </DetailLinkedListView>
    );
}

export {AssetMaintenance};
